import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { I18n } from 'aws-amplify';

export default function DataChangePleaseReloadModal(props) {
    const { isOpen, setIsOpen, content, setClose } = props;

    const onCloseDialogReject = (event, reason) => {
        if (event && reason === "backdropClick") {
            return false;
        }
        
        if (setIsOpen) {setIsOpen(false)}

        if (setClose) {setClose()}
        
        window.location.reload();
    }

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => onCloseDialogReject(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">
                    {content ? content : I18n.get('COMMSG030')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                    onClick={onCloseDialogReject}
                >
                    {I18n.get('COMBTN002')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
